<h5
    class="card-title selenium-card-title rows-{{ rows }}"
    [ngClass]="{ redesign: isRedesignSearchPage }"
    [ngStyle]="{ height: height ? height + 'px' : 'auto' }"
    [attr.title]="titleText || null"
>
    <ng-content></ng-content>
</h5>
